<template>
  <BaseLayout>
    <div class="page-single position-relative">
      <b-container
        fluid
      >
        <b-row class="justify-content-center">
          <b-col class="col-sm-8 col-md-7 col-lg-5 col-xl-6">
            <div class="text-center mb-6">
              <img
                src="/images/smartmatch-logo.png"
                class="h-6"
                alt=""
              >
            </div>

            <b-form
              class="card"
              @submit.prevent="confirm"
            >
              <div class="card-body p-6">
                <div
                  class="card-title"
                  style="font-size: 24px;"
                >
                  Reset Your Password
                </div>
                <b-form-group
                  id="password-group"
                  label="Password*"
                  label-for="password-input"
                  label-class="form-label"
                >
                  <b-form-input
                    id="password-input"
                    v-model="password"
                    type="password"
                    required
                    placeholder="Password"
                    autocomplete="off"
                    data-test="password-input"
                    @blur.native="checkIfPasswordsValid"
                    :class="{ 'is-invalid': password && !passwordMeetsRequirements }"
                  />
                  <p
                    v-if="password && !passwordMeetsRequirements"
                    class="invalid"
                  >
                    Supplied password does not meet the requirements
                  </p>
                </b-form-group>
                <b-form-group
                  id="repeat-password-group"
                  label="Repeat Password*"
                  label-for="repeat-password-input"
                  label-class="form-label"
                >
                  <b-form-input
                    id="repeat-password-input"
                    v-model="repeatPassword"
                    type="password"
                    required
                    placeholder="Repeat Password"
                    autocomplete="off"
                    data-test="repeat-password-input"
                    @blur.native="passwordsMatch = password === repeatPassword"
                    :class="{ 'is-invalid': repeatPassword && !passwordsMatch }"
                  />
                  <p
                    v-if="repeatPassword && !passwordsMatch"
                    class="invalid"
                  >
                    Passwords do not match
                  </p>
                </b-form-group>
                <b-alert
                  show
                  variant="info"
                  class="multiline"
                >
                  Password requirements:
                  <ul class="mb-0 pl-3">
                    <li>Minimum length of 8 characters</li>
                    <li>At least 1 number</li>
                    <li>
                      At least 1 special character from this set:<br>
                      ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > ' : ; | _ ~ `
                    </li>
                    <li>At least 1 uppercase letter</li>
                    <li>At least 1 lowercase letter</li>
                  </ul>
                </b-alert>
                <div class="form-footer">
                  <button
                    type="submit"
                    class="btn btn-primary btn-block"
                    :disabled="isLoginButtonDisabled"
                    data-test="forgot-password-confirm-submit"
                    :class="{ 'btn-loading': isLoading }"
                  >
                    Reset Password & Log in
                  </button>
                </div>
              </div>
            </b-form>
            <div class="text-center text-muted mt-4">
              Need support? Contact our team <a
                href="mailto:support@smartology.net"
                target="_blank"
              >support@smartology.net</a>
            </div>
          </b-col>
        </b-row>
        <div
          class="header-brand d-flex justify-content-center mb-5 mr-0 smartology-logo-footer"
          style="z-index: 0;"
        >
          <a
            target="_blank"
            href="https://www.smartology.net/"
          >
            <img
              src="/images/logo.png"
              class="h-7 header-brand-img mr-0"
              alt="Smartology"
            >
          </a>
        </div>
      </b-container>
    </div>
  </BaseLayout>
</template>

<script>
import signUtils from '@/core/signUtils';
import { mapActions, mapState } from 'vuex';
import * as types from '@/modules/authentication/store/types';

export default {
  name: 'ConfirmForgottenPassword',
  data() {
    return {
      email: '',
      password: '',
      repeatPassword: '',
      code: '',
      showEmailInput: true,
      clicked: false,
      isLoading: false,
      passwordsMatch: true,
      passwordMeetsRequirements: true,
    };
  },
  computed: {
    ...mapState('authentication', {
      user: 'user',
    }),
    allFieldsPresent() {
      return (!this.email || !this.code || !this.password || !this.repeatPassword);
    },
    isLoginButtonDisabled() {
      return this.allFieldsPresent
        || (this.password !== this.repeatPassword)
        || !signUtils.doesPasswordMeetRequirements(this.password);
    },
  },
  methods: {
    ...mapActions('authentication', [
      types.FORGOT_PASSWORD,
      types.CONFIRM_FORGOT_PASSWORD,
    ]),
    confirm() {
      if (this.clicked) return;
      this.clicked = true;
      this.isLoading = true;

      this.CONFIRM_FORGOT_PASSWORD({
        email: this.email,
        code: this.code,
        newPassword: this.password,
      })
        .then(() => {
          this.clicked = false;
          this.isLoading = false;
          // this.$router.push('/login');
          this.$router.push(this.$route.query.redirect
            ? `/login?redirect=${this.$route.query.redirect}`
            : '/login');
        })
        .catch(() => {
          this.clicked = false;
          this.isLoading = false;
        });
    },
    resend() {
      this.FORGOT_PASSWORD(this.email)
        .then(() => {
          // this.$router.push('/confirm-forgotten-password');
          this.$router.push(this.$route.query.redirect
            ? `/confirm-forgotten-password?redirect=${this.$route.query.redirect}`
            : '/confirm-forgotten-password');
        });
    },
    checkIfPasswordsValid() {
      this.passwordMeetsRequirements = signUtils.doesPasswordMeetRequirements(this.password);
      if (this.repeatPassword) this.passwordsMatch = this.password === this.repeatPassword;
    },
  },
  created() {
    const {
      email,
      code,
    } = this.$route.query;

    if (email && code) {
      this.email = email;
      this.code = code;
    }
  },
};
</script>
